import { Avatar, Flex, Spacer, Text } from "@chakra-ui/react";
import CardDefault from "components/Cards/CardDefault";
import ModalDetalheReserva from "components/ModalDetalheReserva";
import { TagStatusReserva } from "components/Tags/TagStatusReserva";
import { DashboardReservasItem } from "core/features/dashboards/typings";
import colors from "core/resources/theme/colors";
import moment from "moment";
import { useState } from "react";
import OutlineButton from "ui/components/Button/OutlineButton";

interface CardItemReservaProps {
  item: DashboardReservasItem;
}

function CardItemReserva({ item }: CardItemReservaProps) {
  const [isOpenModal, setIsOpenModal] = useState(false);

  return (
    <CardDefault mt="16px" p="16px">
      <Flex>
        <Avatar
          mr="16px"
          backgroundColor="#eceff2"
          color={colors.gray}
          name={item.pessoa?.nome}
          src={item.pessoa?.imagemUrl}
        />
        <Flex flexDir="column" w="60%">
          <Text fontSize="14px" fontWeight="bold">
            {item.pessoa.nome}
          </Text>

          <Flex>
            <Text fontSize="12px" fontWeight="300">
              {item.descricao}
            </Text>
          </Flex>

          {item.tenant ? (
            <Flex>
              <Text fontSize="11px" fontWeight="500">
                {item.tenant.nome}
              </Text>
            </Flex>
          ) : null}
        </Flex>
        <Spacer />
        <Flex
          flexDir="column"
          justifyContent="space-between"
          alignItems="flex-end"
        >
          {item.statusId ? <TagStatusReserva statusId={item.statusId} /> : null}

          <Text fontSize="12px" fontWeight="300" mt="auto">
            {item.unidade.numero} -{" "}
            {moment(item.createdAt).format("DD/MM/YYYY")} às{" "}
            {moment(item.createdAt).format("HH:mm")}
          </Text>
        </Flex>
      </Flex>

      <Flex justifyContent="flex-end" mt="8px">
        <OutlineButton onClick={() => setIsOpenModal(true)}>
          Ver detalhes
        </OutlineButton>
      </Flex>

      {isOpenModal ? (
        <ModalDetalheReserva
          isOpen={isOpenModal}
          onClose={() => setIsOpenModal(false)}
          reservaId={item.id}
        />
      ) : null}
    </CardDefault>
  );
}

export default CardItemReserva;
